var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"120px"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"8"}},[(_vm.currentPost)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.currentPost.FullContent)}})]:_vm._e()],2),_c('b-col',{attrs:{"lg":"4"}},[_c('div',[_c('RightMenu',{attrs:{"postData":_vm.getPostData}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }